import { render } from "./TemplatesPanel.vue?vue&type=template&id=111ff0a9&ts=true"
import script from "./TemplatesPanel.vue?vue&type=script&lang=ts"
export * from "./TemplatesPanel.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src417059150/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__